import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { AppError } from "@obg/ngx.core";
import { TranslationService } from "@obg/ngx.core.content";
import { of } from "rxjs";
import { catchError, filter, map, switchMap, withLatestFrom } from "rxjs/operators";

import { CommonState } from "../state";

import { OccupationsAction } from "./occupations.action";
import { OCCUPATIONS_CRS_GROUP_KEY } from "./occupations.const";
import { OccupationsSelector } from "./occupations.selector";

@Injectable()
export class OccupationsEffect {
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(ContentServiceValue.GetOccupations) instead
	 */
	getAll$ = createEffect(() =>
		this.actions$.pipe(
			ofType(OccupationsAction.getAll),
			withLatestFrom(this.store.select(OccupationsSelector.getAll)),
			filter(([, occupations]) => !occupations?.length),
			switchMap(() =>
				this.translationService.getTranslationGroupByNames([OCCUPATIONS_CRS_GROUP_KEY]).pipe(
					map((feed) => {
						const prefix = `${OCCUPATIONS_CRS_GROUP_KEY.toLowerCase()}.`;
						const result = feed
							? Object.keys(feed)
									.filter(
										(key) =>
											key.toLowerCase().startsWith(prefix) &&
											key.length > prefix.length &&
											typeof feed[key] === "string"
									)
									.map((key) => ({
										value: key.substring(prefix.length).toUpperCase(),
										name: feed[key],
									}))
							: undefined;
						return OccupationsAction.getAllSuccess(result);
					}),
					catchError((error: AppError) => of(OccupationsAction.getAllFail(error)))
				)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private translationService: TranslationService,
		private store: Store<CommonState>
	) {}
}
